<template>
  <div>
    <!-- {{ orderListData }} -->
    <ul class="shopping-table mb-3">
      <li class="shopping-table-header d-flex">
        <div>商品資訊</div>
        <div>付款方式</div>
        <div>優惠卷</div>
        <div>價格</div>
        <div>操作</div>
      </li>
      <li
        class="shopping-table-tr d-flex"
        v-for="data in orderListData"
        :key="data.id"
      >
        <div class="d-flex flex-column">
          <p
            v-for="product in data.products"
            :key="product.product.id"
            class="mb-1"
          >
            {{ product.product.title }} * {{ product.quantity }} 件
          </p>
        </div>
        <div>{{ data.payment }}</div>
        <div>{{ data.coupon ? '有' : '無' }}</div>
        <div>{{ $money(data.amount) }}</div>
        <div>
          <el-button
            size="mini"
            type="success"
            @click="orederPayingHandler(data.id)"
            >結帳</el-button
          >
        </div>
      </li>
      <li v-if="orderListData.length <= 0" class="text-center mt-3">
        無訂單
      </li>
    </ul>
  </div>
</template>

<script>
import orderRequest from '@/assets/js/api/front/apiFrontOrder';
import apiFrontOrder from '@/assets/js/api/front/apiFrontOrder';
import { mapState } from 'vuex';
export default {
  created() {
    this.$emit('insideChangeActive', 3);
    this.initOrderListDataHandler();
  },
  computed: {
    ...mapState(['user']),
  },
  data() {
    return {
      orderListData: [],
    };
  },
  methods: {
    initOrderListDataHandler() {
      orderRequest
        .get('')
        .then(res => {
          this.orderListData = res.data.data.filter(data => {
            return !data.paid;
          });
        })
        .catch(err => {
          this.$fire({
            title: `${err}`,
            type: 'error',
            timer: 3000,
          });
        });
    },
    orederPayingHandler(id) {
      apiFrontOrder
        .post(`/${id}/paying`, {
          uuid: this.user.uuid,
          id,
        })
        .then(res => {
          if (res.status === 200) {
            this.$fire({
              title: `付款成功`,
              type: 'success',
              timer: 3000,
            });
            this.$fire({
              title: '結帳成功，是否繼續購物?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: '是',
              cancelButtonText: '否',
            }).then(result => {
              if (result.value === true) {
                this.$router.push({ name: 'products' });
                return;
              }
              this.$router.push({ name: 'home' });
            });
          }
        })
        .catch(err => {
          this.$fire({
            title: `${err}`,
            type: 'error',
            timer: 3000,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
